var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27691_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.2564C17.2574 17.6819 14.0572 20.1667 10.2766 20.1667C5.61352 20.1667 1.83334 16.3865 1.83334 11.7234C1.83334 7.94283 4.3181 4.74258 7.74362 3.66669",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.087 9.11831C19.1139 5.63233 16.3677 2.88606 12.8817 1.91297C11.375 1.49241 10.0833 2.79965 10.0833 4.36388V10.5005C10.0833 11.2826 10.7174 11.9166 11.4995 11.9166H17.6361C19.2003 11.9166 20.5076 10.6249 20.087 9.11831Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27691_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.c5452ebf53e8dcd7fb05648690868712.svg";
export { ForwardRef as ReactComponent };